import { render, staticRenderFns } from "./Animals.vue?vue&type=template&id=68b82d5e"
import script from "./Animals.vue?vue&type=script&lang=js"
export * from "./Animals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports